import Icon from '@ant-design/icons';

const SubitemIconSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon Placer">
        <path
          id="Vector"
          d="M2.50049 2.65625L3.43799 2.65625C3.50674 2.65625 3.56299 2.7125 3.56299 2.78125L3.56299 10.875L11.1567 10.875V9.73438C11.1567 9.62969 11.2786 9.57031 11.3599 9.63594L13.5771 11.3859C13.592 11.3976 13.6041 11.4126 13.6124 11.4296C13.6207 11.4467 13.625 11.4654 13.625 11.4844C13.625 11.5033 13.6207 11.5221 13.6124 11.5391C13.6041 11.5562 13.592 11.5711 13.5771 11.5828L11.3599 13.3328C11.2771 13.3984 11.1567 13.3391 11.1567 13.2344V12.0625L3.37549 12.0625C2.82393 12.0625 2.37549 11.6141 2.37549 11.0625L2.37549 2.78125C2.37549 2.7125 2.43174 2.65625 2.50049 2.65625Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const SubitemIcon = (props: any) => <Icon component={SubitemIconSvg} {...props} />;
